import { Avatar, Box, Paper, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useCurrentOperator } from '@/auth/authHooks';
import { useOptionalReseller } from '@/reseller/resellerContext';
import { initialsOf, resolveTokens } from '@/theme';
import { LanguageChips } from './LanguageChips';
import { ThemeModeToggle } from './ThemeModeToggle';

export function ProfilePanel() {
  const { t } = useTranslation();
  const tokens = resolveTokens(useTheme());
  const operator = useCurrentOperator();
  const reseller = useOptionalReseller();
  const displayName = operator?.name ?? operator?.email ?? '';

  return (
    <Paper variant="outlined" sx={{ p: 1.5 }}>
      <Stack direction="row" spacing={1.5} sx={{ alignItems: 'flex-start' }}>
        <Avatar
          sx={{
            width: 40,
            height: 40,
            bgcolor: tokens.brandSoft,
            color: tokens.link,
            fontSize: 16,
          }}
        >
          {initialsOf(displayName)}
        </Avatar>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="overline" sx={{ color: tokens.text2 }}>
            {t('shell.profile')}
          </Typography>
          {displayName ? (
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {displayName}
            </Typography>
          ) : null}
          {operator?.email ? (
            <Typography variant="caption" sx={{ display: 'block', color: tokens.text2 }}>
              {operator.email}
            </Typography>
          ) : null}
          {operator ? (
            <Typography variant="caption" sx={{ display: 'block', color: tokens.text2 }}>
              {t(`roles.${operator.role}`)}
            </Typography>
          ) : null}
          {reseller?.resellerName ? (
            <Typography variant="caption" sx={{ display: 'block', color: tokens.text2 }}>
              {reseller.resellerName}
            </Typography>
          ) : null}
        </Box>
      </Stack>
      <Box sx={{ mt: 1.5 }}>
        <Typography variant="caption" sx={{ display: 'block', color: tokens.text2, mb: 0.5 }}>
          {t('theme.label')}
        </Typography>
        <ThemeModeToggle variant="segmented" />
      </Box>
      <Box sx={{ mt: 1.5 }}>
        <Typography variant="caption" sx={{ display: 'block', color: tokens.text2, mb: 0.5 }}>
          {t('shell.language')}
        </Typography>
        <LanguageChips />
      </Box>
      <Typography variant="caption" sx={{ display: 'block', color: tokens.text2, mt: 1.5 }}>
        {t('shell.profileNote')}
      </Typography>
    </Paper>
  );
}
